export default {"src":"/_next/static/media/icone-helio.5150d8c6.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};